
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 46","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M3.066 1H42.33c1.142 0 2.067.926 2.067 2.067v39.262a2.066 2.066 0 01-2.067 2.068H3.066A2.067 2.067 0 011 42.329V3.067C1 1.926 1.925 1 3.066 1z","stroke":"#3C8600","stroke-width":"2","stroke-dasharray":"5,5"}}),_c('path',{attrs:{"d":"M29.023 32.316c0 1.658-1.042 2.145-2.327 1.09L13.939 22.924c-.57-.469-.564-1.219.019-1.677l12.7-10.012c1.306-1.03 2.365-.52 2.365 1.138v19.943z","fill":"#3C8600"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/tabs/network/FDC.svg